var hslRegex = require('hsl-regex')

function isHsl (str) {
  return hslRegex({exact: true}).test(str)
}

module.exports = isHsl



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-color/lib/isHsl.js
// module id = 189
// module chunks = 0